export default {
  toasts: {
    auth_token_invalid: 'Ugyldigt godkendelsestoken',
    host_access_refused:
      'Denne adresse tilhører en partner, som din konto ikke er en del af. Log ind på din egen adresse.',
  },
};
